export default __webpack_public_path__ + "static/media/waste-water.f9d83a6c.png";